export const resetFormaPagamento = {
  des_tecla: null,
  cod_finalizadora: '',
  vlr_parcela: '',
  qtd_parcelas: 1,
  venc_parcela: '',
};
